import { useEffect, useState } from "react";
import { notification } from "antd";

import { getFriendlyErrorMessage } from "@/shared/services/http";

import { ClientJobsHttpService } from "../services/ClientJobsHttpService";

export function useAllClientJobTitles({ clientId, locale }: { clientId: number; locale?: string }) {
  const [clientJobTitles, setClientJobTitles] = useState<string[]>();

  useEffect(() => {
    let isCurrent = true;

    const fetchClientJobTitles = async () => {
      try {
        const data = await ClientJobsHttpService.getClientJobTitles({ clientId, locale });
        if (isCurrent) {
          setClientJobTitles(data);
        }
      } catch (error: unknown) {
        if (isCurrent) {
          notification.error({
            message: getFriendlyErrorMessage(error) ?? "Failed to load client job titles. Please try again.",
          });
        }
      }
    };

    setClientJobTitles(undefined);
    fetchClientJobTitles();

    return () => {
      isCurrent = false;
    };
  }, [clientId, locale]);

  return { clientJobTitles };
}
